import { Trans } from "@lingui/react";
import React from "react";

function TransKeyNotFound() {
  return (
    <div className="d-none">
      <Trans id="search" />
    </div>
  );
}

export default TransKeyNotFound;
